import createIcon from '../../createIcon';

/**
 * @component @name NearbyError
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMDAyMSA3LjU3MjA3TDE2LjQyMjEgMTEuOTkyMUwxMi4wMDIxIDE2LjQxMjFMNy41ODIwNyAxMS45OTIxTDEyLjAwMjEgNy41NzIwN1pNMTIuMDAyMSAxOS4xOTIxTDQuODAyMDcgMTEuOTkyMUwxMi4wMDIxIDQuNzkyMDdMMTguMDAyMSAxMC43OTIxVjcuMTYyMDdMMTMuNDIyMSAyLjU4MjA3QzEyLjY0MjEgMS44MDIwNyAxMS4zNzIxIDEuODAyMDcgMTAuNTkyMSAyLjU4MjA3TDIuNTgyMDcgMTAuNTgyMUMxLjgwMjA3IDExLjM2MjEgMS44MDIwNyAxMi42MzIxIDIuNTgyMDcgMTMuNDEyMUwxMC41OTIxIDIxLjQxMjFDMTEuMzcyMSAyMi4xOTIxIDEyLjY0MjEgMjIuMTkyMSAxMy40MjIxIDIxLjQxMjFMMTguMDAyMSAxNi44MjIxVjEzLjE5MjFMMTIuMDAyMSAxOS4xOTIxWk0yMC4wMDIxIDIwLjAwMjFIMjIuMDAyMVYyMi4wMDIxSDIwLjAwMjFWMjAuMDAyMVpNMjIuMDAyMSAxMC4wMDIxSDIwLjAwMjFWMTguMDAyMUgyMi4wMDIxVjEwLjAwMjFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NearbyError = createIcon('NearbyError', [
  [
    'path',
    {
      d: 'M12.0021 7.57207L16.4221 11.9921L12.0021 16.4121L7.58207 11.9921L12.0021 7.57207ZM12.0021 19.1921L4.80207 11.9921L12.0021 4.79207L18.0021 10.7921V7.16207L13.4221 2.58207C12.6421 1.80207 11.3721 1.80207 10.5921 2.58207L2.58207 10.5821C1.80207 11.3621 1.80207 12.6321 2.58207 13.4121L10.5921 21.4121C11.3721 22.1921 12.6421 22.1921 13.4221 21.4121L18.0021 16.8221V13.1921L12.0021 19.1921ZM20.0021 20.0021H22.0021V22.0021H20.0021V20.0021ZM22.0021 10.0021H20.0021V18.0021H22.0021V10.0021Z',
      key: '1pqrcg',
    },
  ],
]);

export default NearbyError;
